<div class="pill" [style.backgroundColor]="color">
  <ng-content></ng-content>
</div>